import { runInAction, makeAutoObservable } from "mobx";
import { callRemoteMethod } from "../utils/WebserviceHandler";
import CONSTANTS from "../utils/constants"

import { ErrorWrapper } from "../utils/ErrorWrapper"
import { SuccessWrapper } from "../utils//SuccessMessage";
import nocsRequestsStore from "./NocsRequestsStore";
// import getPDCConnectorAccountList from "./NocsRequestsStore"
import { toJS, values } from "mobx";
import User from "../stores/UserStore";
import { NotifyError } from "../../src/utils/ShowError";
import generalStore from "./GeneralStore";
interface Obj {
  [key: string]: any;
}

class Cards {
  accountsList: Obj[] = [];
  list: Obj = {};
  addedCardResponse: Obj = {};
  addedAccountResponse: Obj = {};
  cardChange: Obj = {};

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true, deep: true });
  }

  getAccountsList = ErrorWrapper(async () => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.CARD_ACCOUNTS,
    });

    runInAction(() => {
      this.accountsList = res.result?.accounts;
    });
    return res;
  });

  getCardsList = ErrorWrapper(async () => {
   try{ const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.CARDS_LIST });
    runInAction(() => {
      this.list = res.result;
    });}catch(err){
      
    }
  });

  addCard = async ({
    expiryMonth,
    expiryYear,
    last4,
    paymentMethod,
    token,
  }: {
    expiryMonth: string;
    expiryYear: string;
    last4: string;
    paymentMethod: string;
    token: string;
  }) => {
    const data = {
      card: {
        expiryMonth,
        expiryYear,
        last4,
        paymentMethod,
      },
      token,
      platform: "web",
    };

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.CARD_ADD,
      type: "POST",
      data,
    });

    runInAction(() => {
      this.addedCardResponse = res.result;
    });
  };
  // Pay PDC plan
  pdcPAymentsCard = ErrorWrapper(async (actuallData: any) => {
    const {
      token,
      paymentRequestType,
      type,
      tokenNumber,
      totalAmountSelected,
      status,
      corelationID,
    } = actuallData;

    const combinedObject: { [key: string]: any } = {};
    console.log(combinedObject);
    if (nocsRequestsStore?.connectorAccounts[0]) {
      for (const [key, value] of Object.entries(
        nocsRequestsStore?.connectorAccounts[0]
      )) {
        combinedObject[key] = value;
      }
    }
    if (nocsRequestsStore?.serviceAccounts[0]) {
      for (const [key, value] of Object.entries(
        nocsRequestsStore?.serviceAccounts[0]
      )) {
        combinedObject[key] = value;
      }
    }
    const {
      accountId,
      accountType,
      amountDue,
      premiseDetails,
      customerName,
      premiseUsage,
      sewerageNo,
    } = combinedObject;

    const data = {
      token, //ok
      tokenNumber, //ok
      paymentRequestType, //ok
      type, //ok
      status: "", //pk
      platform: "Web", //ok
      personId: User.info.personId, //ok
      personName: "", //ok
      email: null, //ok
      acctType: "",
      totalAmountToPay: totalAmountSelected, //ok
      totalAmountSelected,
    };

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.PDC_Payment,
      type: "POST",
      data,
    });
    return res;
    // runInAction(() => { this.addedCardResponse = res.result })
  });
  changeDate = ErrorWrapper(async (data: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.CARD_CHANGE_DATE,
      type: "POST",
      data,
    });
    if (res?.message == "Success") {
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.CARDS_LIST,
      });
      runInAction(() => {
        this.list = res.result;
      });
    }
    SuccessWrapper(res?.result?.message);

    return res;
  });
  changeCard = ErrorWrapper(async (data: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.CARD_CHANGE,
      type: "POST",
      data,
    });
    if (res?.message == "Success") {
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.CARDS_LIST,
      });
      runInAction(() => {
        this.list = res.result;
      });
    }
    SuccessWrapper(res?.result?.message);
    return res;
  });

  deleteCard = ErrorWrapper(
  async (payload: { previousPaymentId: string; gatewayCdField?: string }) => {
    try {
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.DELETE_CARD(
          payload.previousPaymentId,
          payload.gatewayCdField
        ),
        type: "DELETE",
      });
     
      if (res?.message == "Success") {
        const res = await callRemoteMethod({
          endpoint: CONSTANTS.URL.CARDS_LIST,
        });
        runInAction(() => {
          this.list = res.result;
        });
      }
      SuccessWrapper(res?.result?.message,res?.message);
      return res;
    }catch(error){
      NotifyError(generalStore?.codeLabels['cm_msg_92000_109']?.label);
    }
  });

  addAccount = ErrorWrapper(async (data: any) => {
    try {
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.ACCOUNT_ADD,
        type: "POST",
        data,
      });
      if (res?.message == "Success") {
        const res = await callRemoteMethod({
          endpoint: CONSTANTS.URL.CARDS_LIST,
        });
        runInAction(() => {
          this.list = res.result;
        });
      }
      if (res?.message == "Failed") {
        const message = generalStore?.codeLabels[res?.result?.message]?.label;
        NotifyError(message);
      }
      // SuccessWrapper(res?.result?.message)
      runInAction(() => {
        this.addedAccountResponse = res.result;
      });
      return res?.result;
    } catch (error: any) {
      // const message =error?.error[0]?.message;
      const message = generalStore?.codeLabels[error?.error[0]?.message]?.label;
        NotifyError(message);
    }
  });

  disableAutopay = ErrorWrapper(async (data: any) => {
    try {
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.DISABLE_AUTOPAY,
        type: "POST",
        data,
      });
      return res;
    } catch (error: any) {
      const message =error?.error[0]?.message;
        NotifyError(message);
    }
  });

    saveCard = ErrorWrapper(async (data: { sessionId: string }) => {
  const res = await callRemoteMethod({
    endpoint: CONSTANTS.URL.SAVE_CARD,
    type: "POST",
    data: {
      ...data,
      platform: "Web",
    }
  });
  return res;
});
}


const cardsStore = new Cards()
export default cardsStore;